import { render, staticRenderFns } from "./tmscoldChainList.vue?vue&type=template&id=5542f3b2&scoped=true"
import script from "./tmscoldChainList.vue?vue&type=script&lang=js"
export * from "./tmscoldChainList.vue?vue&type=script&lang=js"
import style0 from "./tmscoldChainList.vue?vue&type=style&index=0&id=5542f3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5542f3b2",
  null
  
)

export default component.exports